import { useQuery, QueryResult } from '@eika-infrastruktur/react-query';

import getDocumentsWaitingForSigning from '../services/ahvService';

const useDocumentsWaitingForSigning = (enabled = false): QueryResult<number> =>
    useQuery({ queryKey: ['documents-waiting-for-signing'], queryFn: getDocumentsWaitingForSigning, enabled });

export default useDocumentsWaitingForSigning;
